module.exports = require("./ur-IN.js");